<template>
    <div class='qipao' :style="{'left':left,'top':top}">
        <div class='qipao_item' >
            <!-- <el-tooltip content="46套" placement="top" effect="dark" > -->
                <div class="paopao">
                    <div  class="qipao-main" @mouseover="mouseover" @mouseout="mouseout" @click.stop="click">{{floorIndex}}<br/>{{num}}</div>
                </div>
            <!-- </el-tooltip> -->
            <div class="qipao-line"></div>
            <div class="map-point-di-animate"
                :class="{'map-point-di-animate-active':animate,
            'map-point-di-animate-init':!animate,
            'map-point-di-animate-middle':type==='middle',
            }">
                <div class="point"></div>

                <div class="waiquan">
                    <div class="waiquan">
                        <div class="neiquan">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            left:{
                type: [String,Number],
                default: function () {
                    return ''
                }
            },
            top:{
                type:[String,Number],
                default: function () {
                    return ''
                }
            },
            floorIndex:{
                type:String,
                default: function () {
                    return ''
                }
            },
            num:{
                type:String,
                default: function () {
                    return ''
                }
            }
        },
        data(){
            return{
                type:'middle',
                animate:true
            }
        },
        mounted(){
            let that = this;
            setTimeout(() => {
                //根据页面调整高度
                that.onWindowResize()
                window.addEventListener('resize',function(){
                that.onWindowResize();
            })
            }, 10);
        },
        methods:{
             onWindowResize(){
                let pageHeight = document.documentElement.clientHeight; //页面总高度
                if(document.querySelectorAll(".floor_area") && document.querySelectorAll(".floor_area")[0]){
                    document.querySelectorAll(".floor_area")[0].style.height =  pageHeight - 240 + 'px';  //在这里可以根据你的边距做调整
                }
            },
            mouseover(event) {
                this.$emit('mouseover', event);
            },
            mouseout(event) {
            this.$emit('mouseout', event);
            },
            click(event) {
                this.$emit('qipaoClick', event);
            }
        }
    }
   
</script>

<style lang="less" scoped>
    .qipao{          
        position: absolute;
        // left: 40%;
        // top: 40%;
        z-index: 8;
        .qipao_item{
            width: 100px;
            position: absolute;
            left:20%;
            .paopao {
                width: auto;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                position: absolute;
                left: 24px;
                top: -7px;
                .qipao-main {
                    width: 60px;
                    height: 60px;
                     cursor: pointer;
                    border-radius: 100%;
                    flex: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    background-color: #00ff00;
                    opacity: .8;
                    box-shadow: inset 0px 1px 5px 2px #938c8c;
                    border: 5px solid #00ff00;
                    color: black;
                    font-weight: bold;

                }
            }  
            .qipao-line{
                height: 150px;
                position: relative;
                bottom: -50px;
                left: 53px;
                width: 2px;
                flex: none;
                border-style: solid;
                border-width: 1px;
                border-image-slice: 1;
                border-image-source: linear-gradient(180deg, #00ff00 0%, rgba(20, 230, 198, 0.28) 100%);
            }
            .map-point-di-animate {
                transform: rotatex(60deg);
                flex: none;
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;

                .point {
                    width: 25px;
                    height: 15px;
                    border-radius: 60%;
                    position: absolute;
                    
                }

                .neiquan {
                    width: 60px;
                    height: 60px;
                    border-radius: 100%;
                    flex: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .waiquan {
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    flex: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .waiquan {
                        width: 60px;
                        height: 60px;
                    }
                }
            }

            .map-point-di-animate-active {
                .neiquan {
                    animation: neiwidthzoom 1.5s ease-out 0s infinite;
                }

                .waiquan {
                    animation: waiwidthzoom 1.5s ease-out 0s infinite;

                    .waiquan {
                        animation: waiwidthzoom 1.5s ease-out .4s infinite;
                    }
                }

            }

        .map-point-di-animate-middle {
            .point {
                background-color: #00ff00;
                box-shadow: 0px 0px 4px 4px #00ff00;
            }
            .neiquan {
                // background-color: rgba(20, 230, 198, 0.6);
                background: #00ff00;
                opacity: 0.6;

            }
            .waiquan {
                border: dashed 1px #00ff00;
            }

        }

        @keyframes neiwidthzoom {
            0% {
                width: 20px;
                height: 20px;
            }

            80% {
                opacity: .8
            }

            100% {
                width: 50px;
                height: 50px;
                opacity: 0;
            }
        }

        @keyframes waiwidthzoom {
            0% {
                width: 30px;
                height: 30px;
            }

            100% {
                width: 80px;
                height: 80px;

            }
        }
         }

    }
</style>



// WEBPACK FOOTER //
// src/page/main_content/floor_distribution/qipao.vue